import React from "react";

const Social = () => {
  return (
    <div className="home__social">
      <a
        href="https://www.instagram.com/himalrajbhusal/"
        class="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
        title="Himal Raj Bhusal's Instagram"
      >
        <i class="uil uil-instagram"></i>
      </a>

      <a
        href="https://www.linkedin.com/in/himalraj07/"
        class="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
        title="Himal Raj Bhusal's LinkedIn"
      >
        <i class="uil uil-linkedin-alt"></i>
      </a>

      <a
        href="https://github.com/himalraj07"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
        title="Himal Raj Bhusal's Github"
      >
        <i className="uil uil-github-alt"></i>
      </a>

      <a
        href="https://twitter.com/himalrajbhusal"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
        title="Himal Raj Bhusal's twitter"
      >
        <i className="uil uil-twitter-alt"></i>
      </a>

      <a
        href="https://www.youtube.com/@UntilEndGaming"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
        title="Himal Raj Bhusal's YouTube"
      >
        <i className="uil uil-youtube"></i>
      </a>

      <a
        href="https://www.facebook.com/Himalrajbhusal"
        className="home__social-icon"
        target="_blank"
        rel="noopener noreferrer"
        title="Himal Raj Bhusal's Facebook"
      >
        <i className="bx bxl-facebook"></i>
      </a>
    </div>
  );
};

export default Social;
